import { render, staticRenderFns } from "./MobileFrame.vue?vue&type=template&id=224293e8&scoped=true"
import script from "./MobileFrame.vue?vue&type=script&lang=js"
export * from "./MobileFrame.vue?vue&type=script&lang=js"
import style0 from "./MobileFrame.vue?vue&type=style&index=0&id=224293e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "224293e8",
  null
  
)

export default component.exports